import { business } from "@/lib/business-data";

/**
 * The brand lockup.
 *
 * The mark is served as WebP in two widths so a phone downloads roughly a
 * seventh of what the source PNG weighs, while a 3x display still gets enough
 * pixels. `business.logo` (the PNG) is deliberately left alone — it is the URL
 * referenced by the schema.org and Open Graph markup, where a PNG is expected.
 */
const SRC_SET = "/logo-200.webp 200w, /logo-400.webp 400w";
const FALLBACK = "/logo-200.webp";

interface Props {
  /** Rendered height in CSS pixels — drives `sizes` and the reserved box. */
  height: number;
  className?: string;
  /** Eager for the header and loader mark; lazy for the footer. */
  loading?: "eager" | "lazy";
  /** Decorative uses (the loader already names the business in text). */
  decorative?: boolean;
}

/** The source lockup is 602x414, so width tracks height at this ratio. */
const RATIO = 602 / 414;

const BrandLogo = ({ height, className = "", loading = "eager", decorative = false }: Props) => {
  const width = Math.round(height * RATIO);

  return (
    <img
      src={FALLBACK}
      srcSet={SRC_SET}
      sizes={`${width}px`}
      width={width}
      height={height}
      loading={loading}
      decoding="async"
      className={className}
      {...(decorative
        ? { alt: "", "aria-hidden": true as const }
        : { alt: `${business.name} logo` })}
    />
  );
};

export default BrandLogo;
